import Auth from "./Auth";
import LockScreen from "./LockScreen";
export default { Auth, LockScreen };
